import { s, Shape } from "@kosmod/pancake";
import { doorLogic } from "./door";
import { visibilitySourceLogic } from "./visibility";
import { adventureLogic } from "./adventure";
import { alignmentLogic, renderLogic } from "./graphics";
import { Logic } from ".";
import { managementLogic } from "./management";

export const allLogic = [
  doorLogic,
  visibilitySourceLogic,
  renderLogic,
  alignmentLogic,
  managementLogic.autoPopulateLogic,
  ...adventureLogic,
] as const;
type LogicList = typeof allLogic;
export type LogicKey = typeof allLogic[number]["key"];

export const AnyLogicState = s.ref<AnyLogicState, "force">()(s.du('key', Object.fromEntries(allLogic.map(logic => {
  return [logic.key, { data: logic.state, enabled: s.bool }]
}))))

export type LogicStateByKey = {
  [Key in LogicKey]: Logic.StateOf<Extract<LogicList[number], { key: Key }>>
};
export type AnyLogicState = LogicStateByKey[LogicKey]

